import * as editorScript from '@ps/bridge/qc/scripts/editor'
import gameIframe from '@ps/bridge/iframe/iframe'
import _ from 'lodash'
import { EditorDataScript } from '@ps/bridge/qc/scripts/editor'
import { GlobalConfigBgClass, VPGamePlayClass } from '@ps/bridge/qc/base'
import { globalVarItem } from '@ps/workbench/undo-redo/module/global-var-action'
import { hasPlaysmartGlobalVars } from '@ps/store/workbench/visual-program/utils'

export const addLanguage = (lang: string): void => {
  const gamePlay = gameIframe.gamePlay
  const ped = editorScript.getScript(gamePlay) as EditorDataScript
  if (!_.isArray(ped.languageConfig.langList)) {
    ped.languageConfig.langList = []
  }
  ped.languageConfig.langList.push(lang)
}

export const getLanguages = () => {
  const gamePlay = gameIframe.gamePlay
  const ped = editorScript.getScript(gamePlay) as EditorDataScript
  return ped.languageConfig.langList
}

export const deleteLanguage = (lang: string): void => {
  const gamePlay = gameIframe.gamePlay
  const ped = editorScript.getScript(gamePlay) as EditorDataScript
  if (ped.languageConfig.langList) {
    const langList = [...Object.values(ped.languageConfig.langList)]
    ped.languageConfig.langList = langList.filter((_lang) => {
      return _lang !== lang
    })
  } else {
    console.error('langList为空')
  }
}

export const getBgmBehavior = () => {
  const iframeWindow = gameIframe.iframe
  if (iframeWindow && iframeWindow.ps && iframeWindow.ps.GlobalConfigBg) {
    const gamePlay = gameIframe.gamePlay
    let temp = gamePlay.getScript(GlobalConfigBgClass)
    if (typeof temp === 'undefined') {
      temp = gamePlay.addScript(GlobalConfigBgClass)
    }
    return temp
  }
  return null
}

export const updateGamePlayGlobalVar = (data: globalVarItem[]) => {
  const gamePlay = gameIframe.gamePlay
  const vgp = gamePlay.getScript(VPGamePlayClass)
  data.forEach((item) => {
    if (item.id) {
      vgp[item.id] = item.value
    } else {
      vgp[item.globalVarKey] = item.value
    }
  })
  if (hasPlaysmartGlobalVars()) {
    vgp.playsmartGlobalVars = data
  }
}
